import { useTranslation } from '@/shared/i18n/use-translation';
import { cn } from '@/shared/lib/cn';
import { Badge } from '@/shared/ui/badge/badge';
import type { Priority } from './priority';
import { PRIORITY_LABELS } from './priority-labels';

type PriorityBadgeProps = {
  readonly priority: Priority;
};

const TONE: Readonly<Record<Priority, string>> = {
  high: 'bg-danger/12 text-danger',
  medium: 'bg-warn/15 text-[color-mix(in_oklch,var(--warn),black_35%)] dark:text-warn',
  low: 'bg-muted text-muted-foreground',
};

/** Only what departs from the default says something: medium shows nothing. */
export function PriorityBadge({ priority }: PriorityBadgeProps) {
  const { t } = useTranslation();
  if (priority === 'medium') return null;
  return (
    <Badge variant="secondary" className={cn('border-0', TONE[priority])}>
      {t(PRIORITY_LABELS[priority])}
    </Badge>
  );
}
